import { combineReducers } from '@reduxjs/toolkit'
import { otherStatistics } from './statistics/reducers'

export const otherReducer = combineReducers({
	otherStatistics,
})
